import { render } from "./ArticleComponent.vue?vue&type=template&id=4243c288"
import script from "./ArticleComponent.vue?vue&type=script&lang=js"
export * from "./ArticleComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/konradmilewski/Projects/AppWorks/janpawelvue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__